<div class="change-quantity flex-row justify-end align-center">
  <!-- Boutton moins-->
  <mat-icon
    class="change-quantity-button"
    (click)="onDecreaseQuantity()"
    matRipple
    [matRippleDisabled]="quantity === minQuantity"
    [ngClass]="{'change-quantity-button-disabled': quantity === minQuantity}"
    >remove</mat-icon
  >

  <!-- Quantité-->
  <div class="change-quantity-value">{{ quantity }}</div>

  <!-- Boutton plus-->
  <mat-icon
    class="change-quantity-button"
    (click)="onIncreaseQuantity()"
    matRipple
    [matRippleDisabled]="quantity === maxQuantity"
    [ngClass]="{'change-quantity-button-disabled': quantity === maxQuantity}"
  >
    add</mat-icon
  >
</div>
